// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function NonRotated(props) {
  let __rotateAround = props.rotateAround;
  let rotateAround = __rotateAround !== undefined ? __rotateAround : V2f$Linear.zero;
  let transformComponents = Transform$Linear.M23f.toSimpleTransform(props.outerTransform);
  let facilityMapRotation = transformComponents.rotate;
  let undoRotation = Transform$Linear.M23f.rotationAround(- facilityMapRotation, rotateAround);
  let undoMirror = transformComponents.mirror ? Transform$Linear.M23f.mirrorAround(rotateAround) : Transform$Linear.M23f.identity;
  let nonRotatedLabel = Transform$Linear.M23f.compose(undoMirror, undoRotation);
  return JsxRuntime.jsx("g", {
    children: props.children,
    className: props.className,
    transform: LumiSVG.Transform.Matrix.fromM23f(nonRotatedLabel)
  });
}

let make = NonRotated;

export {
  make,
}
/* LumiSVG Not a pure module */
